import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { StorageService } from '../services/storage.service';
import { Encrypted, Configuration } from '../Constants/configuration';
import { RequestServices } from '../services/request.service';
import { LogConsumoFunciones } from '../utilities/logConsumo';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-login-ayuda',
    templateUrl: './login-ayuda.component.html'
})

export class LoginAyudaComponent implements OnInit {
    private cocheSeguro: CocheSeguro = new CocheSeguro();
    public const: Configuration = new Configuration();
    public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
    public logCon: string = "";


    constructor(private snackBar: MatSnackBar, private router: Router, private storageService: StorageService, private routers: ActivatedRoute, private requestService: RequestServices) {
    }

    ngOnInit(): void {

        this.routers.queryParams.subscribe(result => {

            if(result.isEmployee && window.location.hostname == 'cochesegurosivale.inter.mx') {
                sessionStorage.setItem("employeeSivale", 'true');
            }

            if (result.logConsumoId) {                
                sessionStorage.setItem("logConsumoId", result.logConsumoId);
                this.logCon = result.logConsumoId;
                if (this.logCon != new Encrypted().ZERO && this.logCon != "") {
                    this.consulta(this.logCon);
                }
            } else {
                console.error("Error: No params");
            }
        })
    }

    consulta(data) {
        let result: any = "";
        try {
            this.logConsumoFun.getLogJSON(data).subscribe(result => {
                if (result.error) {
                    this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
                } else if (result.json) {

                    this.cocheSeguro = JSON.parse(result.json);
                    this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                    // this.router.navigate([this.cocheSeguro.url]);
                    if (this.const.PLATFORM) {
                        let urlAux: string = '';
                        if (window.location.hostname == 'localhost') {
                            urlAux = 'http://' + window.location.hostname + ':' + window.location.port;
                        } else {
                            urlAux = 'https://' + window.location.hostname;
                        }
                        window.location.href = urlAux + this.paso(this.cocheSeguro.url);
                    } else {
                        this.router.navigate([this.paso(this.cocheSeguro.url)]);
                    }
                }
            });

        } catch (error) {
            console.error("Error", error);
        }
    }


    paso(urls: string) {
        try {
            let urls
            switch (urls) {
                case "/inicio":
                    urls = "/inicio"
                    break;
                case "/cotizacion/inicio":
                    urls = "/cotizacion"
                    break;
                case "/datos-emision":
                    urls = "/datos-emision"
                    break;
                case "/datos-emision-vehiculo":
                    urls = "/datos-emision-vehiculo"
                    break;
                case "/datos-tarjeta":
                    urls = "/datos-tarjeta"
                    break;
                case "/mi-cuenta":
                    urls = "/mi-cuenta/inicio"
                    break;
                default:
                    break;
            }

        } catch (error) {
            console.error("Error paso", error)
        }
        return urls;
    }
}